<template>
  <div class="page_container">
    <div class="page_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="page_card">
      <template>
        <div class="ta-r mb-10">
          <el-button type="primary" size="small" @click="handleClickAdd">新增产品</el-button>
        </div>
        <el-table ref="table1" :data="tableData" style="width: 100%" :height="tableHeight">
          <el-table-column prop="id" align="center" label="序号" width="80"></el-table-column>
          <el-table-column prop="product_name" label="产品名称" width="250" show-overflow-tooltip	>
            <template slot-scope="{row}">
              <span>{{row.product_name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="模块名称" min-width="150" show-overflow-tooltip	>
            <template slot-scope="{row}">
<!--              <span v-for="item in row.modules" v-if="item.module_name">{{item.module_name}}</span>-->
              <span v-text="row.modules.map(map => map.module_name).join('，')"></span>
            </template>
          </el-table-column>

          <el-table-column prop="handle" align="center" fixed="right" label="操作" width="80" >
            <template slot-scope="{row}">
                <el-button type="text" size="small" @click="handleClickEdit(row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>


<!--      <el-pagination background-->
<!--                     @size-change="handleSizeChange"-->
<!--                     @current-change="handleCurrentChange"-->
<!--                     :current-page="pagination.pageNum"-->
<!--                     :page-sizes="pagination.pageSizes"-->
<!--                     :page-size="pagination.pageSize"-->
<!--                     :layout="pagination.layout"-->
<!--                     :total="pagination.total">-->
<!--      </el-pagination>-->
    </el-card>
    <productEdit :productEditVisible.sync="productEditVisible" v-if="productEditVisible" :productId="productId"   @success="handleClickSearch"/>
  </div>
</template>

<script>
import { adminProductList} from '@/api/api'
import {getTableHeight,convertToCurrentTimezone} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";
import productEdit from './component/product_edit.vue'
export default {
  name: 'product',
  components: {
    productEdit
  },
  data() {
    return {
      loading:false,
      tableData:[ ],
      tableHeight:'',
      searchForm:{
        keyWords:''
      },
      productId:0,
      productEditVisible:false
    }
  },

  mixins: [pagination],
  created() {
    //将计算的table高度赋值给table 210
    this.tableHeight = getTableHeight(210)
  },
  mounted() {
    this.getTableData()
    //窗口缩放时动态修改table的高度
    window.onresize = () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      //开启定时器，节流函数
      this.resizeTimer = setTimeout(() => {
        //将计算的table高度赋值给table
        this.tableHeight = getTableHeight(210)
        //清除定时器
        this.resizeTimer = null
      }, 100)
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),
  },
  methods: {
    convertToCurrentTimezone(utcTime,separator,type) {
      return convertToCurrentTimezone(utcTime,separator,type);
    },
    getTableData() {
      this.loading = true
      let postData = {
        page: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        name:this.searchForm.keyWords
      }
      adminProductList(postData).then(res => {
        if (res.code === 200) {
          // let {total, data} = res.data
          this.tableData = res.data
          // this.pagination.total = total
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleClickEdit(row){
      this.productId = row.id
      this.productEditVisible = true
    },
    handleClickAdd(){
      this.productId = 0
      this.productEditVisible = true
    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getTableData()
    },
    // 搜索
    handleClickSearch(){
      this.pagination.pageNum = 1
      this.getTableData()
    },
    // 重置
    handleClickReset(){
      this.searchForm.keyWords = ''
      this.pagination.pageNum = 1
      this.getTableData()
    },

  },
  watch: {

  },
}
</script>

<style scoped lang="scss">
.kx {
  width: 100%;
  height: 30px;
}
.chart{
  height:540px
}
.page_container .page_card {
  overflow-y: scroll;
  padding-bottom: 20px;
}

.filed_list{
  color: #000;
  line-height: 24px;
  font-size: 16px;
  margin-bottom: 12px;
}
</style>
